const catchError = (error) => {
    let errorMsg = "Ops! Something went wrong.";
    if(!!error) {
        if(!!error.data) {
            errorMsg = error.data.message as string;
        } else {
            if (error.status === 404){
                errorMsg = "404: URL Not Found"
            }
            if (error.status === 500){
                errorMsg = "500: Internal Server error."
            }
        }
    }
    return errorMsg;
}

export const exceptionHandler = {
    catchError
};
